// extracted by mini-css-extract-plugin
export var container = "styles-module--container--0Sn41";
export var videoContainer = "styles-module--videoContainer--LNS3q";
export var label1 = "styles-module--label1--d-JIE";
export var sectionDownload = "styles-module--sectionDownload--E8pBc";
export var imgAppStore = "styles-module--imgAppStore--HCby+";
export var imgWave = "styles-module--imgWave--J7W8Z";
export var bottomWrapper = "styles-module--bottomWrapper--lbquX";